import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

import { getUserById, sendSupport } from "../api/api";
import "../HelpandSupport/AdminSupport.css";
import Swal from "sweetalert2";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  subject: Yup.string().required("Subject is required"),
  message: Yup.string().required("Message is required"),
});

const AdminSupport = () => {
  const navigate = useNavigate();
  const subjectRef = useRef(null);
  const messageRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const storedUser = localStorage.getItem("currentUser");
        const parsedUser = JSON.parse(storedUser);
        const _id = parsedUser?.id || parsedUser?._id;

        if (_id) {
          const currentUser = await getUserById({ user_id: _id });
          setUserData(currentUser?.data || {});
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        navigate("/login");
      }
    };

    getUserdata();
  }, [navigate]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userData.name || "",
      email: userData.email || "",
      subject: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        const storedUser = localStorage.getItem("currentUser");
        const parsedUser = JSON.parse(storedUser);
        const _id = parsedUser?.id || parsedUser?._id;

        const requestData = {
          user_id: _id,
          user_name: userData.name,
          user_email: userData.email,
          message: values.message,
          subject: "gs",
          title: values.subject,
        };

        const response = await sendSupport(requestData);
        if (response?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#e04a48",
          }).then(() => {
            navigate("/Sidebar/helpandsupport");
            resetForm();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response?.message || "Something went wrong",
            confirmButtonColor: "#e04a48",
          });
        }
      } catch (error) {
        console.error("Submit error:", error);
        alert("Failed to submit request. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="form-container">
      <h2 className="form-heading">Admin Support Form</h2>

      <input
        type="text"
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="input"
        placeholder="Your Name"
        disabled
      />
      {formik.touched.name && formik.errors.name && (
        <div className="error">{formik.errors.name}</div>
      )}

      <input
        type="email"
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="input"
        placeholder="Your Email"
        disabled
      />
      {formik.touched.email && formik.errors.email && (
        <div className="error">{formik.errors.email}</div>
      )}

      <input
        type="text"
        name="subject"
        value={formik.values.subject}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        ref={subjectRef}
        className="input"
        placeholder="Subject"
      />
      {formik.touched.subject && formik.errors.subject && (
        <div className="error">{formik.errors.subject}</div>
      )}

      <textarea
        name="message"
        value={formik.values.message}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        ref={messageRef}
        className="textarea"
        placeholder="Describe Your Issue"
      />
      {formik.touched.message && formik.errors.message && (
        <div className="error">{formik.errors.message}</div>
      )}

      <button type="submit" className="button" disabled={isLoading}>
        {isLoading ? "Submitting..." : "Submit Request"}
      </button>
    </form>
  );
};

export default AdminSupport;
